// Front-end gate for the four node-allocation page routes. The two
// node_allocation endpoints behind them are sysadmin-only, so those pages must
// not mount for anyone else -- including a direct URL visit -- otherwise a
// non-sysadmin would fire requests the backend rejects and see an empty page.
//
// Identity comes from the app store's current user. The store is imported
// lazily so this module can be referenced from the route definitions without
// pulling the whole store/backend cycle into router evaluation. Every failure
// path denies the navigation.
const DENIED = { name: 'notfound' }

let storePromise = null

function loadStore() {
    if (!storePromise) storePromise = import('@/store').then(module => module.default)
    return storePromise
}

// Resolves once the store is no longer mid-fetch. `getUserInfo` commits its
// result asynchronously, so the resolved value is not usable -- read the store.
function waitForIdentity(store) {
    if (!store.state.fetchingUserInfo) return Promise.resolve()
    return new Promise(resolve => {
        const unwatch = store.watch(
            state => state.fetchingUserInfo,
            fetching => {
                if (!fetching) {
                    unwatch()
                    resolve()
                }
            }
        )
    })
}

async function resolveIdentity(store) {
    if (store.state.fetchingUserInfo) await waitForIdentity(store)
    else await store.dispatch('getUserInfo')
}

export default function sysadminOnly(_to, _from, next) {
    loadStore()
        .then(async store => {
            await resolveIdentity(store)
            if (store.getters.isSysadmin) next()
            else next(DENIED)
        })
        .catch(() => next(DENIED))
}
